'use client';

import {useTranslations, useLocale} from 'next-intl';

const quickLinks = [
  {key: 'home', path: ''},
  {key: 'about', path: '/a-propos'},
  {key: 'programs', path: '/programmes'},
  {key: 'aids', path: '/les-aides'},
  {key: 'projects', path: '/projets'},
  {key: 'contact', path: '/contact'},
] as const;

export default function Footer() {
  const t = useTranslations('footer');
  const tc = useTranslations('common');
  const nav = useTranslations('nav');
  const contact = useTranslations('contact');
  const locale = useLocale();

  return (
    <footer role="contentinfo" className="bg-primary-dark text-white relative overflow-hidden">
      <img
        src="/images/utss/rose.svg"
        alt=""
        aria-hidden="true"
        className="absolute right-4 bottom-2 w-[120px] h-[120px] opacity-5 pointer-events-none select-none"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-wrap items-start justify-between gap-6">
          {/* Logo + nom */}
          <div className="flex items-center gap-2 shrink-0">
            <img src="/images/utss/rose.svg" alt="UTSS" className="h-7 w-auto" />
            <div className="leading-tight">
              <span className="font-bold text-sm block">UTSS</span>
              <span className="text-white/40 text-[9px] block">{tc('solidarity')}</span>
            </div>
          </div>

          {/* Quick Links — inline */}
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            {quickLinks.map(({key, path}) => (
              <a
                key={key}
                href={`/${locale}${path}`}
                className="text-white/60 hover:text-white text-xs transition-colors"
              >
                {nav(key)}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="flex items-center gap-4 text-xs text-white/60">
            <a href="tel:+21671808066" className="hover:text-white transition-colors">(+216) 71 808 066</a>
            <a href="mailto:utss@planet.tn" className="hover:text-white transition-colors">utss@planet.tn</a>
            <div className="flex gap-2">
              <a href="#" className="w-6 h-6 rounded bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" aria-label="Facebook">
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="#" className="w-6 h-6 rounded bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" aria-label="YouTube">
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"/></svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-3 pt-3 border-t border-white/10 flex flex-wrap items-center justify-between gap-2 text-[10px] text-white/40">
          <span>&copy; 2026 {t('copyright')}</span>
          <div className="flex gap-4">
            <a href={`/${locale}/documentation`} className="hover:text-white transition-colors">{t('docs')}</a>
            <a href={`/${locale}/mentions-legales`} className="hover:text-white transition-colors">{t('legal')}</a>
            <a href={`/${locale}/confidentialite`} className="hover:text-white transition-colors">{t('privacy')}</a>
            <a href={`/${locale}/plan-du-site`} className="hover:text-white transition-colors">{tc('sitemap')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
